// Shared icon components — thin wrappers over `<Iconify>` so all hand-rolled
// glyphs continue to live behind the same API while the underlying SVG comes
// from the Iconify registry (see `shared/components/iconify`).
//
// Default sizes are preserved per-icon to match prior visuals.

import { Iconify } from './iconify';

interface IconProps {
  size?: number;
}

export function BookIcon({ size = 22 }: IconProps) {
  return <Iconify icon="custom:book-outline" width={size} />;
}

export function CompassIcon({ size = 22 }: IconProps) {
  return <Iconify icon="custom:compass-outline" width={size} />;
}

export function ShieldIcon({ size = 22 }: IconProps) {
  return <Iconify icon="solar:shield-check-bold" width={size} />;
}

export function HeartIcon({ size = 22 }: IconProps) {
  return <Iconify icon="solar:heart-bold" width={size} />;
}

export function SendIcon({ size = 16 }: IconProps) {
  return <Iconify icon="custom:send-outline" width={size} />;
}

export function MicIcon({ size = 18 }: IconProps) {
  return <Iconify icon="solar:microphone-bold" width={size} />;
}

export function StopIcon({ size = 12 }: IconProps) {
  return <Iconify icon="custom:stop-fill" width={size} />;
}

export function CloseIcon({ size = 16 }: IconProps) {
  return <Iconify icon="mingcute:close-line" width={size} />;
}

export function ArrowUpRightIcon({ size = 18 }: IconProps) {
  return <Iconify icon="eva:diagonal-arrow-right-up-fill" width={size} />;
}

export function CheckIcon({ size = 12 }: IconProps) {
  return <Iconify icon="eva:checkmark-fill" width={size} />;
}

export function BuildingIcon({ size = 24 }: IconProps) {
  return <Iconify icon="custom:building-outline" width={size} />;
}

export function GraduationCapIcon({ size = 24 }: IconProps) {
  return <Iconify icon="custom:graduation-cap-outline" width={size} />;
}

export function UsersIcon({ size = 24 }: IconProps) {
  return <Iconify icon="solar:users-group-rounded-bold" width={size} />;
}

export function ArrowRightIcon({ size = 14 }: IconProps) {
  return <Iconify icon="eva:arrow-forward-fill" width={size} />;
}

export function PlusIcon({ size = 14 }: IconProps) {
  return <Iconify icon="mingcute:add-line" width={size} />;
}

export function GlobeIcon({ size = 16 }: IconProps) {
  return <Iconify icon="custom:globe-outline" width={size} />;
}

export function ChevronDownIcon({ size = 14 }: IconProps) {
  return <Iconify icon="eva:chevron-down-fill" width={size} />;
}

export function SunIcon({ size = 18 }: IconProps) {
  return <Iconify icon="custom:sun-outline" width={size} />;
}

export function MoonIcon({ size = 18 }: IconProps) {
  return <Iconify icon="custom:moon-outline" width={size} />;
}

export function GoogleIcon({ size = 18 }: IconProps) {
  return <Iconify icon="custom:google" width={size} />;
}

export function AppleIcon({ size = 18 }: IconProps) {
  return <Iconify icon="mingcute:apple-fill" width={size} />;
}

export function EyeIcon({ size = 20 }: IconProps) {
  return <Iconify icon="solar:eye-bold" width={size} />;
}

export function EyeOffIcon({ size = 20 }: IconProps) {
  return <Iconify icon="solar:eye-closed-bold" width={size} />;
}

export function SearchIcon({ size = 14 }: IconProps) {
  return <Iconify icon="eva:search-fill" width={size} />;
}

export function MenuIcon({ size = 24 }: IconProps) {
  return <Iconify icon="custom:menu-duotone" width={size} />;
}
